import { h, resolveComponent } from 'vue'

export default {
  render () {
    return h('div', {}, h(resolveComponent('router-view')))
  },
}
